import React from "react"
// import { Loading } from "../../components/ui/loading"
import { useAuth } from "../../contexts/AuthContext"
import LoginPage from "./Login"

const AuthPage = () => {
  const { isLoading } = useAuth()

  if (isLoading) {
    return <div>loading</div>
  }

  return <LoginPage />
}

export default AuthPage
